<template>
  <div>
    <div class="loading-screen" v-if="!isWhiteLabel">
      <aha-logo-loader />
    </div>
    <div class="loading-screen-white-label" v-else>
      <div>
        <aha-spinner size="lg" variant="tail" />
        <p class="mt-6">
          Just a moment please...
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import Utils from '@/util'

export default {
  name: 'LoadingScreen',
  components: {
  },
  computed: {
    isWhiteLabel() {
      return Utils.checkWhiteLabelDomain()
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variable.scss";

.loading-screen {
  background-color: #fff;
  max-height: -webkit-fill-available; // fix height in ios safari (with address bar)
  @apply fixed top-0 left-0 w-full h-full z-50 flex content-center;
  @apply flex-col justify-center items-center;
}

.loading-screen-white-label {
  background-color: #fff;
  @apply fixed top-0 left-0 w-full h-full z-50 flex content-center justify-center items-center;
}
</style>
